import * as yup from 'yup';
import { shippingDetails as TEXT } from 'locales/en/cart';
import { fullNameRegex } from 'utils/yupHelpers';
import { escapedCountryField } from 'utils/transform';

export const FIELD_NAMES = {
  recipient_name: 'recipient_name',
  address_1: 'address_1',
  address_2: 'address_2',
  postcode: 'postcode',
  country: escapedCountryField,
  city: 'city',
};

export const defaultValues = {
  [FIELD_NAMES.recipient_name]: '',
  [FIELD_NAMES.address_1]: '',
  [FIELD_NAMES.address_2]: '',
  [FIELD_NAMES.postcode]: '',
  [FIELD_NAMES.country]: {},
  [FIELD_NAMES.city]: {},
};

const schema = yup.object().shape({
  [FIELD_NAMES.recipient_name]: yup
    .string()
    .matches(fullNameRegex, TEXT.errors.recipient_name.fullName)
    .required(TEXT.errors.recipient_name.required),
  [FIELD_NAMES.address_1]: yup.string().required(TEXT.errors.address.required),
  [FIELD_NAMES.address_2]: yup.string(),
  [FIELD_NAMES.postcode]: yup.string().required(TEXT.errors.postcode.required),
  [FIELD_NAMES.country]: yup.object().shape({
    name: yup.string().required(TEXT.errors.country.required),
    dial_code: yup.string(),
    code: yup.string(),
  }),
  [FIELD_NAMES.city]: yup.object().shape({
    name: yup.string().required(TEXT.errors.city.required),
    value: yup.string(),
  }),
});

export default schema;
